<template>
  <div class="fwidth">
    <iframe ref="playerframe" :src="src" :width="viewWidth" :height="viewHeight" class="mplayer"
      frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
  </div>
</template>

<script>
import vplayer from '@vimeo/player'
import vu from '@/utils/video-parser.js'

export default {
  props: {
    url: String,
    orientation: String,
    muted: Boolean,
    autoplay: Boolean,
    inpage: Boolean
  },
  computed: {
    src () {
      if(this.url) {
        let code = vu.getVimeoCode(this.url)
        let mted = ''
        if(this.muted) mted += '&muted=1'
        if(this.autoplay) mted += '&autoplay=1'
        if(!this.inpage) mted += '&loop=1&autopause=0'
        return `https://player.vimeo.com/video/${code}?v=1${mted}`
      }
      return ''
    },
    viewHeight: function () {
      if(this.orientation === 'tall'){
        return Math.round(this.viewWidth * 1.25)
      }
      else if(this.orientation === 'square') {
        return Math.round(this.viewWidth)
      }
      return Math.round(this.viewWidth * 0.5625)
    }
  },
  data () {
    return {
      viewWidth:640,
      metapaused: false
    }
  },
  mounted () {
    let vm = this
    this.player = new vplayer(this.$refs.playerframe)
    this.player.on('bufferstart', () => {
      this.updateWidth()
    })
    this.player.ready().then(function() {
      vm.$emit('load')
      vm.updateWidth()
      if(vm.autoplay) {
        vm.player.play()
      }
    });
    this.updateWidth()
  },
  methods: {
    updateWidth: function () {
      this.viewWidth = this.$el.offsetWidth
    }
  },
  watch: {
    '$store.state.stopPreviews': function () {
      if(this.inpage) {
        if(this.player) {
          if(this.$store.state.stopPreviews) {
            if(!this.player.getPaused()){
              this.player.pause()
              this.metapaused = true
            }
          }
          else {
            if(this.autoplay && this.metapaused) {
              this.player.play()
              this.metapaused = false
            }
          }
        }
      }
      
    }
  }
  
}
</script>

<style scoped>
.fwidth{
  width:100%;

}
.mplayer{
  display:block;
  width:100%;
}
</style>